export default {
  title: 'Tafels',
  count_one: '{{count}} tafel',
  count_other: '{{count}} tafels',
  filtered_count: '{{shown}} van {{count}} tafels',
  intro:
    'Elke tafel heeft een eigen link en QR-code. Gasten die deze scannen, bestellen voor die tafel en jij ziet de tafel bij elke bestelling.',
  migrated: {
    title: 'Kamer-/tafelservice is nu Tafelbestellen',
    description:
      'We hebben voor elk van je locaties een tafel toegevoegd, met de naam van de locatie, zodat gasten kunnen blijven bestellen. Hernoem ze naar je eigen tafels of voeg er meer toe.',
  },
  add: {
    label: 'Tafel toevoegen',
    placeholder: 'bijv. 7, 1A of Terras 2',
    button: 'Tafel toevoegen',
  },
  errors: {
    empty: 'Voer een tafelnaam in.',
    duplicate: 'Er is al een tafel met de naam “{{name}}”.',
    too_long: 'De naam van een tafel mag maximaal {{max}} tekens bevatten.',
  },
  columns: {
    order: 'Volgorde',
    table: 'Tafel en link',
    on: 'Aan',
    copy: 'Link kopiëren',
    qr: 'QR-code',
    actions: 'Acties',
  },
  switch: {
    on: 'Aan',
    off: 'Uit',
  },
  buttons: {
    copy: 'Link kopiëren',
    copied: 'Gekopieerd',
    download_qr: 'QR-code downloaden',
    qr_short: 'QR-code',
    rename: 'Hernoemen',
    delete: 'Verwijderen',
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  aria: {
    move: '{{name}} verplaatsen (pijltjestoetsen)',
    switch: '{{name}} aan',
    copy: 'Link kopiëren voor {{name}}',
    copied: 'Link gekopieerd',
    download_qr: 'QR-code downloaden voor {{name}}',
    rename: '{{name}} hernoemen',
    delete: '{{name}} verwijderen',
    more: 'Meer voor {{name}}',
    new_name: 'Nieuwe naam voor {{name}}',
  },
  tooltips: {
    move: 'Sleep om te herordenen',
    move_disabled: 'Wis de zoekopdracht om te herordenen',
  },
  rename_hint: 'De link en QR-code blijven hetzelfde.',
  no_link: 'Nog geen shopadres',
  search: {
    placeholder: 'Tafels zoeken',
    no_results: 'Geen tafel met de naam “{{text}}”.',
  },
  load_failed: {
    title: 'De tafels konden niet worden geladen.',
    retry: 'Opnieuw proberen',
  },
  empty: {
    title: 'Nog geen tafels',
    text: 'Voeg hierboven je tafels toe om voor elk een link en QR-code te krijgen. Gasten kunnen pas aan tafel bestellen als je er een toevoegt.',
  },
  delete: {
    title: 'Tafel “{{name}}” verwijderen?',
    warning:
      'Afgedrukte QR-codes van deze tafel werken niet meer. Gasten die er een scannen, krijgen de melding het personeel te vragen.',
    softer: 'Wil je bestellingen aan deze tafel tijdelijk stoppen, zet de tafel dan uit.',
    confirm: 'Tafel verwijderen',
    cancel: 'Annuleren',
  },
  announcements: {
    moved: '“{{name}}” verplaatst naar positie {{position}} van {{count}}.',
    instructions: 'Om een tafel te verplaatsen, selecteer je de greep en druk je op de pijl omhoog of omlaag.',
  },
  qr_image: {
    table: 'Tafel',
  },
  toasts: {
    added: 'Tafel “{{name}}” toegevoegd',
    renamed: '“{{old}}” hernoemd naar “{{name}}”',
    deleted: 'Tafel “{{name}}” verwijderd',
    switched_on: '“{{name}}” aangezet',
    switched_off: '“{{name}}” uitgezet',
    failed_to_save: 'Opslaan is niet gelukt. Probeer het opnieuw.',
    failed_to_reorder: 'De nieuwe volgorde is niet opgeslagen. Probeer het opnieuw.',
    failed_to_download_qr: 'De QR-code kon niet worden opgeslagen. Probeer het opnieuw.',
    copy_failed: 'De link kon niet worden gekopieerd. Probeer het opnieuw.',
  },
};
